import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { OrderDataService } from "../../providers/order-data-service/order-data-service";

/**
 * Generated class for the MultiSelectDrugComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "multi-select-drug",
  templateUrl: "multi-select-drug.html",
})
export class MultiSelectDrugComponent implements OnInit, OnDestroy {
  text: string;
  @Input() parentForm: FormGroup;
  @Input() controlName: string;
  @Input() isSearchable: boolean = true;
  @Input() extraClass: string;
  @Input() orderType: string;
  @Input() view: boolean = false;
  @Input() patientData: any;
  @Input() addStandingOrder: boolean = false;
  @Input() dosageOptions: any;
  @Input() frequencyOptions: any;

  drugArray: any;
  protected incomingData: any = {};
  creatinineClearanceNeeded: boolean = false;

  constructor(
    private dataService: OrderDataService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    // get the incoming array in local variable
    this.drugArray = this.parentForm.controls[this.controlName];

    // if array is empty, add new blank record. if records are already present, add validation rules
    if (!this.drugArray.length && !this.view && !this.addStandingOrder) {
      this.drugArray.push(this.createRelatedDrug("", 0));
    } else {
      for (let control of this.drugArray.controls) {
        if (control.controls["drugText"]) {
          control.controls["drugText"].setValidators([Validators.required]);
          control.controls["drugText"].updateValueAndValidity();
        }
        if (control.controls["otherDescription"]) {
          control.controls["otherDescription"].setValidators([
            Validators.required,
          ]);
          control.controls["otherDescription"].updateValueAndValidity();
        }
        if (control.controls["dosingParameters"]) {
          control.controls["dosingParameters"].setValidators([
            Validators.required,
          ]);
          control.controls["dosingParameters"].updateValueAndValidity();
        }
      }
    }
  }

  ngOnDestroy() {
    // remove the validation rules before destroying
    for (let control of this.drugArray.controls) {
      if (control.controls["drugText"]) {
        control.controls["drugText"].setValidators(null);
        control.controls["drugText"].updateValueAndValidity();
      }
      if (control.controls["otherDescription"]) {
        control.controls["otherDescription"].setValidators(null);
        control.controls["otherDescription"].updateValueAndValidity();
      }
      if (control.controls["dosingParameters"]) {
        control.controls["dosingParameters"].setValidators(null);
        control.controls["dosingParameters"].updateValueAndValidity();
      }
    }
  }

  searchRelatedDrugOptions(event, index) {
    if (this.isSearchable == false) return;
    let relatedCtrl = this.drugArray.controls[index],
      searchTermCtrl = relatedCtrl.controls["searchTerm"],
      hideSearchOptionsCtrl = relatedCtrl.controls["hideSearchOptions"],
      currentSearchingCtrl = relatedCtrl.controls["currentSearching"],
      searchOptionsCtrl = relatedCtrl.controls["searchOptions"];

    let searchTerm = event.value.toLowerCase();

    let displayedOptions = relatedCtrl.controls["searchOptions"].value;
    if (
      displayedOptions.filter((drug) => drug.name.toLowerCase() === searchTerm)
        .length === 0 &&
      searchTerm.length >= 3
    ) {
      hideSearchOptionsCtrl.setValue(false);
      currentSearchingCtrl.setValue(true);
      searchTermCtrl.setValue(searchTerm);

      this.dataService.getMedications(searchTerm).subscribe(
        (data) => {
          data = data.filter((drug) => this.drugNotSelected(`${drug.name}`));
          if (searchTerm === searchTermCtrl.value) {
            searchOptionsCtrl.setValue(data);
            currentSearchingCtrl.setValue(false);
          }
        },
        (err) => {
          console.error(err);
          currentSearchingCtrl.setValue(false);
        }
      );
    } else {
      hideSearchOptionsCtrl.setValue(true);
    }
  }

  drugNotSelected(drugDescription: string) {
    let arr = [];
    if (this.drugArray) {
      for (let drug of this.drugArray.controls) {
        if (drug.controls["drugText"]) {
          let value = drug.controls["drugText"].value;
          arr.push(value);
        }
      }
    }
    return arr.indexOf(drugDescription) === -1;
  }

  addDrug(val: string = "", id: number = null): void {
    this.drugArray.push(this.createRelatedDrug(val, id));
  }

  createRelatedDrug(val: string = "", id: number = null): FormGroup {
    let formObject = {
      drugObject: [""],
      searchTerm: [""],
      searchOptions: [[]],
      hideSearchOptions: [true],
      currentSearching: [false],
      isHospicePayer: [false],
      isOpioid: [false],
      id: [id],
    };
    if (this.orderType === "other") {
      formObject["otherDescription"] = [
        "",
        Validators.compose([Validators.required]),
      ];
    } else if (this.orderType === "otherMed") {
      formObject["otherDescription"] = [
        "",
        Validators.compose([Validators.required]),
      ];
      formObject["drugText"] = [val, Validators.compose([Validators.required])];
    } else {
      formObject["drugText"] = [val, Validators.compose([Validators.required])];
    }
    return this.formBuilder.group(formObject);
  }

  removeDrug(index): void {
    this.drugArray.removeAt(index);
  }

  setRelatedDrug(index, drug: any) {
    let relatedCtrl = this.drugArray.controls[index];
    relatedCtrl.controls["drugText"].setValue(`${drug.name}`);
    relatedCtrl.controls["drugObject"].setValue(drug);
    relatedCtrl.controls["id"].setValue(drug.id);
    relatedCtrl.controls["hideSearchOptions"].setValue(true);
  }

  onDosingParamterSelect(data, index) {
    let relatedCtrl = this.drugArray.controls[index];
    if (relatedCtrl.controls["dosageParameterOptions"]) {
      let index = relatedCtrl.controls["dosageParameterOptions"].value.indexOf(
        relatedCtrl.controls["dosageParameterOptions"].value.find(
          (param) => param.value === data
        )
      );
      if (index > -1) {
        //index will be -1 if user selects 'Other'
        relatedCtrl.controls["frequency"].setValue(
          relatedCtrl.controls["frequencyOptions"].value[index]
        );
        relatedCtrl.controls["dosage"].setValue(
          relatedCtrl.controls["dosageOptions"].value[index]
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/multi-select-drug/multi-select-drug.ts